export const COURSE_SPECIALISATIONS_1_CONSTANTS = {
  DEFAULT_ROW: {
    id: "1",
    // Metadata Fields - Card/Item fields
    title: "",
    desktop_title_text_color: "#000000",
    desktop_active_title_text_color: "#000000",
    mobile_variant_1_title_text_color: "#000000",
    mobile_variant_2_title_text_color: "#000000",
    sub_title: "",
    desktop_sub_title_text_color: "#000000",
    desktop_active_sub_title_text_color: "#000000",
    mobile_variant_2_sub_title_text_color: "#000000",
    description: "",
    desktop_description_text_color: "#000000",
    mobile_variant_1_description_text_color: "#000000",
    mobile_variant_2_description_text_color: "#000000",
    // Icons
    desktop_icon: "",
    desktop_icon_alt: "",
    mobile_variant_1_icon: "",
    mobile_variant_1_icon_alt: "",
    desktop_hover_icon: "",
    desktop_hover_icon_alt: "",
    // Card colors
    desktop_active_card_color: "#FFFFFF",
    desktop_inactive_card_color: "#F5F5F5",
    desktop_gradient_angle: "180deg",
    desktop_gradient_start_color: "rgba(8, 47, 71, 1)",
    desktop_gradient_end_color: "rgba(35, 117, 168, 1)",
    mobile_variant_1_title_card_color: "#FFFFFF",
    mobile_variant_1_description_card_color: "#F5F5F5",
    mobile_variant_2_card_color: "#FFFFFF",
    mobile_variant_2_gradient_angle: "0deg",
    mobile_variant_2_gradient_start_color: "rgba(8, 47, 71, 1)",
    mobile_variant_2_gradient_end_color: "rgba(35, 117, 168, 1)",
    mobile_variant_2_accordion_element_color: "#0A3D5B",
    priority: 1,
    status: true,
  },
  COURSE_SPECIALISATIONS_FIELDS_CONFIG: [
    // Parent Fields
    {
      fieldName: "title",
      label: "Section Title",
      value: "Course Specialisations",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter section title",
      required: false,
      defaultValue: "Course Specialisations",
    },
    {
      fieldName: "title_text_color",
      label: "Section Title Text Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter title text color",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "desktop_background_color",
      label: "Desktop Background Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter desktop background color",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "mobile_variant_1_background_color",
      label: "Mobile Variant 1 Background Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter mobile variant 1 background color",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "mobile_variant_2_background_color",
      label: "Mobile Variant 2 Background Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter mobile variant 2 background color",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "mobile_variant",
      label: "Mobile Variant",
      value: "1",
      valueType: "string",
      filedType: "SELECT",
      placeholder: "Select mobile variant",
      required: false,
      defaultValue: "1",
      options: [
        { value: "1", label: "Mobile Variant 1" },
        { value: "2", label: "Mobile Variant 2" },
      ],
    },
    {
      fieldName: "status",
      label: "Status",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable section",
      required: false,
      defaultValue: false,
    },
    // Mobile Variant 1 Navigation Icons
    {
      fieldName: "mobile_variant_1_left_nav_icon",
      label: "Mobile V1 Left Navigation Icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload left navigation icon",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "mobile_variant_1_left_nav_icon_alt",
      label: "Mobile V1 Left Navigation Icon Alt Text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter left navigation icon alt text",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "mobile_variant_1_right_nav_icon",
      label: "Mobile V1 Right Navigation Icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload right navigation icon",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "mobile_variant_1_right_nav_icon_alt",
      label: "Mobile V1 Right Navigation Icon Alt Text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter right navigation icon alt text",
      required: false,
      defaultValue: "",
    },
    // Mobile Variant 2 Arrow Icons
    {
      fieldName: "mobile_variant_2_top_arrow_icon",
      label: "Mobile V2 Top Arrow Icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload top arrow icon",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "mobile_variant_2_top_arrow_icon_alt",
      label: "Mobile V2 Top Arrow Icon Alt Text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter top arrow icon alt text",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "mobile_variant_2_bottom_arrow_icon",
      label: "Mobile V2 Bottom Arrow Icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload bottom arrow icon",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "mobile_variant_2_bottom_arrow_icon_alt",
      label: "Mobile V2 Bottom Arrow Icon Alt Text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter bottom arrow icon alt text",
      required: false,
      defaultValue: "",
    },
  ],
  METADATA_FIELDS: [
    // Title fields
    {
      header: "Title",
      fieldName: "title",
      label: "Title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter specialisation title",
      required: true,
      defaultValue: "",
    },
    {
      header: "Desktop Title Color",
      fieldName: "desktop_title_text_color",
      label: "Desktop Title Text Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter desktop title text color",
      required: false,
      defaultValue: "#000000",
    },
    {
      header: "Desktop Active Title Color",
      fieldName: "desktop_active_title_text_color",
      label: "Desktop Active Title Text Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter desktop active title text color",
      required: false,
      defaultValue: "#000000",
    },
    {
      header: "Mobile V1 Title Color",
      fieldName: "mobile_variant_1_title_text_color",
      label: "Mobile Variant 1 Title Text Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter mobile variant 1 title text color",
      required: false,
      defaultValue: "#000000",
    },
    {
      header: "Mobile V2 Title Color",
      fieldName: "mobile_variant_2_title_text_color",
      label: "Mobile Variant 2 Title Text Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter mobile variant 2 title text color",
      required: false,
      defaultValue: "#000000",
    },
    // Sub Title fields
    {
      header: "Sub Title",
      fieldName: "sub_title",
      label: "Sub Title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter sub title",
      required: false,
      defaultValue: "",
    },
    {
      header: "Desktop Sub Title Color",
      fieldName: "desktop_sub_title_text_color",
      label: "Desktop Sub Title Text Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter desktop sub title text color",
      required: false,
      defaultValue: "#000000",
    },
    {
      header: "Desktop Active Sub Title Color",
      fieldName: "desktop_active_sub_title_text_color",
      label: "Desktop Active Sub Title Text Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter desktop active sub title text color",
      required: false,
      defaultValue: "#000000",
    },
    {
      header: "Mobile V2 Sub Title Color",
      fieldName: "mobile_variant_2_sub_title_text_color",
      label: "Mobile Variant 2 Sub Title Text Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter mobile variant 2 sub title text color",
      required: false,
      defaultValue: "#000000",
    },
    // Description fields
    {
      header: "Description",
      fieldName: "description",
      label: "Description",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Enter description",
      required: false,
      defaultValue: "",
    },
    {
      header: "Desktop Desc Color",
      fieldName: "desktop_description_text_color",
      label: "Desktop Description Text Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter desktop description text color",
      required: false,
      defaultValue: "#000000",
    },
    {
      header: "Mobile V1 Desc Color",
      fieldName: "mobile_variant_1_description_text_color",
      label: "Mobile Variant 1 Description Text Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter mobile variant 1 description text color",
      required: false,
      defaultValue: "#000000",
    },
    {
      header: "Mobile V2 Desc Color",
      fieldName: "mobile_variant_2_description_text_color",
      label: "Mobile Variant 2 Description Text Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter mobile variant 2 description text color",
      required: false,
      defaultValue: "#000000",
    },
    // Desktop Icon fields
    {
      header: "Desktop Icon",
      fieldName: "desktop_icon",
      label: "Desktop Icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload desktop icon",
      required: false,
      defaultValue: "",
    },
    {
      header: "Desktop Icon Alt",
      fieldName: "desktop_icon_alt",
      label: "Desktop Icon Alt Text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter desktop icon alt text",
      required: false,
      defaultValue: "",
    },
    {
      header: "Desktop Hover Active Icon",
      fieldName: "desktop_hover_icon",
      label: "Desktop Active Icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload desktop hover icon",
      required: false,
      defaultValue: "",
    },
    {
      header: "Desktop Hover Active Icon Alt",
      fieldName: "desktop_hover_icon_alt",
      label: "Desktop Hover Active Icon Alt Text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter desktop hover icon alt text",
      required: false,
      defaultValue: "",
    },
    // Mobile Variant 1 Icon fields
    {
      header: "Mobile V1 Icon",
      fieldName: "mobile_variant_1_icon",
      label: "Mobile Variant 1 Icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload mobile variant 1 icon",
      required: false,
      defaultValue: "",
    },
    {
      header: "Mobile V1 Icon Alt",
      fieldName: "mobile_variant_1_icon_alt",
      label: "Mobile Variant 1 Icon Alt Text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter mobile variant 1 icon alt text",
      required: false,
      defaultValue: "",
    },
    // Mobile Variant 1 Navigation icons
    // {
    //   header: "Mobile V1 Left Nav Icon",
    //   fieldName: "mobile_variant_1_left_nav_icon",
    //   label: "Mobile Variant 1 Left Navigation Icon",
    //   value: "",
    //   valueType: "string",
    //   filedType: "FILE",
    //   placeholder: "Upload left navigation icon",
    //   required: false,
    //   defaultValue: "",
    // },
    // {
    //   header: "Mobile V1 Left Nav Alt",
    //   fieldName: "mobile_variant_1_left_nav_icon_alt",
    //   label: "Mobile Variant 1 Left Navigation Icon Alt Text",
    //   value: "",
    //   valueType: "string",
    //   filedType: "INPUT",
    //   placeholder: "Enter left navigation icon alt text",
    //   required: false,
    //   defaultValue: "",
    // },
    // {
    //   header: "Mobile V1 Right Nav Icon",
    //   fieldName: "mobile_variant_1_right_nav_icon",
    //   label: "Mobile Variant 1 Right Navigation Icon",
    //   value: "",
    //   valueType: "string",
    //   filedType: "FILE",
    //   placeholder: "Upload right navigation icon",
    //   required: false,
    //   defaultValue: "",
    // },
    // {
    //   header: "Mobile V1 Right Nav Alt",
    //   fieldName: "mobile_variant_1_right_nav_icon_alt",
    //   label: "Mobile Variant 1 Right Navigation Icon Alt Text",
    //   value: "",
    //   valueType: "string",
    //   filedType: "INPUT",
    //   placeholder: "Enter right navigation icon alt text",
    //   required: false,
    //   defaultValue: "",
    // },
    // Desktop Card Colors
    {
      header: "Desktop Active Card",
      fieldName: "desktop_active_card_color",
      label: "Desktop Active Card Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter desktop active card color",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      header: "Desktop Inactive Card",
      fieldName: "desktop_inactive_card_color",
      label: "Desktop Inactive Card Color",
      value: "#F5F5F5",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter desktop inactive card color",
      required: false,
      defaultValue: "#F5F5F5",
    },
    {
      header: "Desktop Gradient Angle",
      fieldName: "desktop_gradient_angle",
      label: "Desktop Gradient Angle",
      value: "180deg",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter gradient angle (e.g., 180deg, to right, 90deg)",
      required: false,
      defaultValue: "180deg",
    },
    {
      header: "Desktop Gradient Start Color",
      fieldName: "desktop_gradient_start_color",
      label: "Desktop Gradient Start Color",
      value: "rgba(8, 47, 71, 1)",
      valueType: "string",
      filedType: "RGBA",
      placeholder: "rgba(8, 47, 71, 1)",
      required: false,
      defaultValue: "rgba(8, 47, 71, 1)",
    },
    {
      header: "Desktop Gradient End Color",
      fieldName: "desktop_gradient_end_color",
      label: "Desktop Gradient End Color",
      value: "rgba(35, 117, 168, 1)",
      valueType: "string",
      filedType: "RGBA",
      placeholder: "rgba(35, 117, 168, 1)",
      required: false,
      defaultValue: "rgba(35, 117, 168, 1)",
    },
    // Mobile Variant 1 Card Colors
    {
      header: "Mobile V1 Title Card",
      fieldName: "mobile_variant_1_title_card_color",
      label: "Mobile Variant 1 Title Card Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter mobile variant 1 title card color",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      header: "Mobile V1 Desc Card",
      fieldName: "mobile_variant_1_description_card_color",
      label: "Mobile Variant 1 Description Card Color",
      value: "#F5F5F5",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter mobile variant 1 description card color",
      required: false,
      defaultValue: "#F5F5F5",
    },
    // Mobile Variant 2 Card Colors
    {
      header: "Mobile V2 Card Color",
      fieldName: "mobile_variant_2_card_color",
      label: "Mobile Variant 2 Card Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter mobile variant 2 card color",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      header: "Mobile V2 Gradient Angle",
      fieldName: "mobile_variant_2_gradient_angle",
      label: "Mobile Variant 2 Gradient Angle",
      value: "0deg",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter gradient angle (e.g., 0deg, 180deg, to bottom)",
      required: false,
      defaultValue: "0deg",
    },
    {
      header: "Mobile V2 Gradient Start Color",
      fieldName: "mobile_variant_2_gradient_start_color",
      label: "Mobile Variant 2 Gradient Start Color",
      value: "rgba(8, 47, 71, 1)",
      valueType: "string",
      filedType: "RGBA",
      placeholder: "rgba(8, 47, 71, 1)",
      required: false,
      defaultValue: "rgba(8, 47, 71, 1)",
    },
    {
      header: "Mobile V2 Gradient End Color",
      fieldName: "mobile_variant_2_gradient_end_color",
      label: "Mobile Variant 2 Gradient End Color",
      value: "rgba(35, 117, 168, 1)",
      valueType: "string",
      filedType: "RGBA",
      placeholder: "rgba(35, 117, 168, 1)",
      required: false,
      defaultValue: "rgba(35, 117, 168, 1)",
    },
    {
      header: "Mobile V2 Accordion Color",
      fieldName: "mobile_variant_2_accordion_element_color",
      label: "Mobile Variant 2 Accordion Element Color",
      value: "#0A3D5B",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter mobile variant 2 accordion element color",
      required: false,
      defaultValue: "#0A3D5B",
    },
    {
      header: "Priority",
      fieldName: "priority",
      label: "Priority",
      value: 1,
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Enter priority",
      required: true,
      defaultValue: 1,
    },
    {
      header: "Status",
      fieldName: "status",
      label: "Status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable",
      defaultValue: true,
    },
  ],
};

